import { render, staticRenderFns } from "./newcomer_modal.vue?vue&type=template&id=13106fe0&"
import script from "./newcomer_modal.vue?vue&type=script&lang=js&"
export * from "./newcomer_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports